export type AppMode =
  'menu' | 'editor' | 'test' | 'ride-first-person' | 'ride-third-person' | 'error-recovery';

const legalTransitions: Readonly<Record<AppMode, ReadonlySet<AppMode>>> = {
  menu: new Set(['editor', 'test', 'error-recovery']),
  editor: new Set(['menu', 'test', 'error-recovery']),
  test: new Set(['editor', 'ride-first-person', 'ride-third-person', 'error-recovery']),
  'ride-first-person': new Set(['ride-third-person', 'editor', 'test', 'error-recovery']),
  'ride-third-person': new Set(['ride-first-person', 'editor', 'test', 'error-recovery']),
  'error-recovery': new Set(['menu', 'editor']),
};

export function canTransition(from: AppMode, to: AppMode): boolean {
  return from === to || legalTransitions[from].has(to);
}

export function transitionMode(from: AppMode, to: AppMode): AppMode {
  if (!canTransition(from, to)) {
    throw new Error(`Illegal app-mode transition: ${from} -> ${to}`);
  }
  return to;
}
